import UI from 'root/ui';
import Cache from 'root/cache';
import Form from 'root/module/form';
import View from 'view/base';

var Account_Refer = View.extend({
    className: 'account-refer-dialog',

    timeout: null,

    events: {
        'submit form.copy-input'      : 'emailFriend',
        'click .fa-copy'              : 'copyLink',
        'click .share-facebook'       : 'shareFacebook',
        'click .share-twitter'        : 'shareTwitter',
        'click .share-linkedin'       : 'shareLinkedin'
    },

    dom_handlers: {
        emailFriend: function(e) {
            e.preventDefault();

            var form = this.$el.find('form.copy-input');
            var form_data = Form.getData(form);

            form.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            Cache.app.request({
                action: 'account/referFriends',
                data: form_data,
                context: this,
                success: function(response) {
                    this.$el.find('form input[name="email"]').val('');

                    this.$el.find('form button')
                        .removeClass('primary loading')
                        .addClass('success')
                        .html('<i class="fad fa-thumbs-up pulse animated"></i>');

                    this.$el.find('.email-success').show();

                    this.timeout = setTimeout(function() {
                        this.$el.find('form button')
                            .removeClass('success')
                            .addClass('primary')
                            .text('Send');

                        this.$el.find('.email-success').hide();
                    }.bind(this), 4000);
                },
                complete: function() {
                    form.find('button[type="submit"]').removeClass('loading').prop('disabled', false);
                }
            });
        },

        copyLink: function(e) {
            e.preventDefault();

            try {
                var range = document.createRange();
                range.selectNode(this.$el.find('.referral-link > span').get(0));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand('copy');

                UI.success('Referral link copied');
            } catch (e) {
            }
        },

        shareFacebook: function(e) {
            var facebook_url = 'https://www.facebook.com/dialog/share';
            facebook_url += '?display=popup';
            facebook_url += '&href=' + encodeURIComponent(this.referral_url + '&sq=1');
            facebook_url += '&quote=Tired of handling customer feedback over email? Try userback.io. It\'s the easiest way to get visual feedback in real time. Use this link to get your first month for just $1! ' + this.referral_url;
            facebook_url += '&app_id=' + encodeURIComponent(Cache.app.configs.facebook_app_id);

            window.open(facebook_url, '_blank', 'width=600, height=530, scrollbars=no');
        },

        shareTwitter: function(e) {
            var tweet_url = 'https://twitter.com/intent/tweet';
            tweet_url += '?text=Tired of handling customer feedback over email? Try userback.io. It\'s the easiest way to get visual feedback in real time. Use this link to get your first month for just $1!';
            tweet_url += '&url=' + encodeURIComponent(this.referral_url);

            window.open(tweet_url, '_blank', 'width=600, height=500, scrollbars=no');
        },

        shareLinkedin: function(e) {
            var linkedin_url = 'https://www.linkedin.com/shareArticle';
            linkedin_url += '?mini=true';
            linkedin_url += '&summary=Tired of handling customer feedback over email? Try userback.io. It\'s the easiest way to get visual feedback in real time. Use this link to get your first month for just $1! ' + this.referral_url;
            linkedin_url += '&url=' + encodeURIComponent(this.referral_url);

            window.open(linkedin_url, '_blank', 'width=900, height=800, scrollbars=no');
        }
    },

    event_handlers: {
        onRemove: function() {
            clearTimeout(this.timeout);
        }
    },

    initialize: function(options) {
        this.referral_url = 'https://www.userback.io/?rc=' + Cache.account.get('referral_code');

        this.listenTo(this, 'remove', this.event_handlers.onRemove);
    },

    render: function() {
        var content = '';

        content += '<img src="/image/referred.png">';
        content += '<h2 class="hero-text">You can earn up to $589 per referral!</h2>';

        content += '<div class="hero-desc">';
        content +=     '<div class="info">Share your referral link and invite friends to Userback. If they upgrade, they get their first month for $1 and we\'ll pay the full retail value of their first month to you. <a href="https://support.userback.io/en/articles/5209194" target="helper" class="info" rel="noopener">Learn more</a>.</div>';
        content +=     '<div class="margin-top-20 font-weight-medium info">Share your referral link</div>';
        content +=     '<div class="referral-link text-align-center">';
        content +=     '<span>' + this.referral_url + '</span> <a href="#"><i class="far fa-copy text-primary tooltip" data-title="Copy your referral link"></i></a>';
        content +=     '</div>';
        content += '</div>';

        content += '<div class="referral-footer">';
        content +=     '<div class="grid-9">';
        content +=         '<div class="hero-form">';
        content +=             '<form class="copy-input">';
        content +=                 '<div class="margin-bottom-0"><input type="email" name="email" placeholder="Enter your friend\'s email address" required></div>';
        content +=                 '<button type="submit" class="primary medium">Send</button>';
        content +=                 '<div class="email-success">Email sent!</div>';
        content +=             '</form>';
        content +=         '</div>';
        content +=     '</div>';
        content +=     '<div class="grid-3 social-share">';
        content +=         '<div class="tooltip share-facebook" data-title="Share on Facebook"><i class="fab fa-facebook"></i></div>';
        content +=         '<div class="tooltip share-twitter" data-title="Share on Twitter"><i class="fab fa-twitter"></i></div>';
        content +=         '<div class="tooltip share-linkedin" data-title="Share on LinkedIn"><i class="fab fa-linkedin"></i></div>';
        content +=     '</div>';
        content += '</div>';



        this.$el.html(content);

        return this;
    }
});

export default Account_Refer;
